export const ServicePathName = {
  MARKETPLACE: 'marketplace',
  SERVICEMANAGE: 'servicemanage',
  SERVICEMANAGE_SHOWCONNECTION: 'servicemanage:showconnection',
  SERVICEMANAGE_OPEN: 'servicemanage:open',
  SERVICEMAPPINGS: 'servicemappings',
  SERVICEOVERVIEW: 'serviceoverview',
  SERVICESETTINGS: 'servicesettings',
  SERVICEDRILLDOWN: 'servicedrilldown',
  SERVICEDRILLDOWN_CLIENT: 'servicedrilldown:client',
};

export const ServiceRoute = {
  MARKETPLACE: 'marketplace',
  OVERVIEW: 'overview',
  SERVICE: 'service',
  SERVICES: 'services',
  SERVICESETTINGS: 'servicesettings',
};

export const RefreshLegacyMdsEvent = 'RefreshLegacyMdsEvent';

export const MappingAssignmentEvent = 'MappingAssignmentEvent';

export const FacebookAdsServiceId = 39;

export const ServiceType = {
  SERVICE: 'service',
  SMART_CONNECTOR: 'smart_connector',
  SC_TEMPLATE: 'sc_template',
};

export const ConnectionType = {
  STORED_CONNECTOR: 'stored_connector',
  ON_DEMAND_CONNECTOR: 'on_demand_connector',
  SMART_CONNECTOR: 'smart_connector',
  SC_TEMPLATE: 'sc_template',
};

export const ConnectionTypeValues = [
  { key: ConnectionType.STORED_CONNECTOR, name: i18n.$t('Stored Connector') },
  { key: ConnectionType.ON_DEMAND_CONNECTOR, name: i18n.$t('On-Demand Connector') },
  { key: ConnectionType.SMART_CONNECTOR, name: i18n.$t('Custom Connector/SmartConnector') },
  {
    key: ConnectionType.SC_TEMPLATE,
    name: i18n.$t('Partner Custom Connector/SmartConnector Template'),
  },
];
